import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, useHistory, Switch } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, SecureRoute, Security } from '@okta/okta-react';
import { Button, Col, Container, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

import config from './config';
// CSS
import './App.scss';
// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
// import Register from './pages/Register';
import IssueRequest from './pages/IssueRequest';
// Components
import Header from "./components/layout/header/Header";
import Footer from './components/layout/navigation/Footer';
import EssilorAdminAuth from "./components/auth/EssilorAdmin";
import Idp from "./pages/Idp";
import RequestList from './pages/RequestList';
import ViewIssue from './pages/ViewIssue';
import EssilorAdmin from "./pages/essilor-admin";
import Auth from "./components/auth/Auth";
import PageNotFound from "./pages/PageNotFound";
import { setMediatorRedirect } from './features/issue/issueSlice';
import { useDispatch } from 'react-redux';
import RegisterAdmin from './pages/RegisterAdmin';
import FrequentlyAskedQuestions from "./pages/FrequentlyAskedQuestions";
import { MsalProvider } from '@azure/msal-react';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthB2C from './components/auth/AuthB2C';
import Reports from './pages/Reports';
// Okta

const oktaAuth = new OktaAuth(config.oidc);

const App = ({msalInstance}) => {
    const wellStyles = { maxWidth: 400, margin: '0 auto 10px' };
    const btnStyles = { width: '100%' };
    // const [authRequiredModalOpen, setAuthRequiredModalOpen] = useState(false);
    const history = useHistory();
    const [showMediatorDialog, setShowMediatorDialog] = useState(false);
    const dispatch = useDispatch();
    const [redirectUrl, setRedirectUrl] = useState('');

    const triggerLogin = async () => {
        // if (!!localStorage.getItem('redirectUrl') && localStorage.getItem('redirectUrl')?.indexOf('mediator') !== -1) {
        //     await history.push('/login');
        // } else {
        await history.push('/dashboard');
        // }
    };


    const customAuthHandler = async () => {
        const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
        if (!previousAuthState || !previousAuthState.isAuthenticated) {
            // App initialization stage
            if (history.location.pathname.indexOf('mediator') !== -1) {
                setRedirectUrl(history.location.pathname);
                setShowMediatorDialog(true);
            }
            oktaAuth.token.getWithoutPrompt({
                responseType: 'id_token', // or array of types
                sessionToken: 'testSessionToken' // optional if the user has an existing Okta session
            })
                .then(function(res) {
                    var tokens = res.tokens;
                    // Do something with tokens, such as
                    oktaAuth.tokenManager.setTokens(tokens);
                })
                .catch(async function (err) {
                    // handle OAuthError or AuthSdkError (AuthSdkError will be thrown if app is in OAuthCallback state)
                    await triggerLogin();
                });
        } else {
            // Ask the user to trigger the login process during token autoRenew process
            // setAuthRequiredModalOpen(true);
        }
    };

    const handleRestoreOriginalUri = async (_oktaAuth, originalUri) => {
        history.replace(toRelativeUrl(originalUri || '', window.location.origin));
    };

    const handleCloseMediatorDialog = () => {
        setShowMediatorDialog(false);
    }

    const handleMediatorLogin = (path) => {
        dispatch(setMediatorRedirect(redirectUrl))
        localStorage.setItem('redirectUrl', redirectUrl);
        history.push(path)
        handleCloseMediatorDialog();
    }

    const handleMediatorCancel = () => {
        history.push('/login')
        handleCloseMediatorDialog();
    }

    useEffect(() => {
        // if (!!localStorage.getItem('redirectUrl') && localStorage.getItem('redirectUrl')?.indexOf('mediator') !== -1) {
        //     const redirectUrl = localStorage.getItem('redirectUrl');
        //     localStorage.removeItem('redirectUrl')
        //     history.push(redirectUrl);
        // } else {
        //     history.push('/');
        // }
    }, [])

    return (
        <>
            <MsalProvider instance={msalInstance}>
              <Header/>
              <Switch>
                <Route exact path="/" component={Dashboard}></Route>
                <Route path="/dashboard" component={Dashboard}/>
                <ProtectedRoute exact path="/essilor-admin" component={EssilorAdmin}/>
                <Route path="/issue-request" component={IssueRequest}/>
                <Route path="/issue/view/:issueId" component={ViewIssue}/>
                <ProtectedRoute path="/issue/mediator/:issueId" component={ViewIssue}/>
                <ProtectedRoute path="/requests" component={RequestList}/>
                <ProtectedRoute path="/essiloradmin/user/register" component={RegisterAdmin}/>
                <Route path="/faqs" component={FrequentlyAskedQuestions}/>
                <Route path="/page-not-found" component={PageNotFound}/>
                <Route path="/auth/essiloradmin" component={EssilorAdminAuth}/>
                <Route path="/auth/b2c" component={AuthB2C}/>
                <Route path="/reports" component={Reports}/>
              </Switch>
                <Footer/>
            </MsalProvider>


            <Modal show={showMediatorDialog} onHide={handleCloseMediatorDialog}>
                <Modal.Header closeButton>
                    <Modal.Title>Login Required</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please login to view the issue/request you are trying to access. You will be redirected to the issue/request once you login.</p>
                    <h4>
                        EssilorUSA Login
                        <OverlayTrigger overlay={
                            <Tooltip>
                                This login would be the same as your login accessing Gmail or Essilor.Okta.com
                            </Tooltip>
                        }>
                            <i className="fa fa-question-circle"></i>
                        </OverlayTrigger>
                    </h4>
                    <div className="well" style={wellStyles}>
                        <Button className="well" style={btnStyles} block size={'lg'} variant="primary" onClick={() => handleMediatorLogin('/auth/essiloradmin')}>EssilorUSA Login</Button>
                    </div>

                    <p></p>
                    <h4>
                        External Login
                        <OverlayTrigger overlay={
                            <Tooltip>
                                This login would be provided by someone on the Medical Affairs team that assigned you as a Specialist/Mediator for a particular topic.
                            </Tooltip>
                        }>
                            <i className="fa fa-question-circle"></i>
                        </OverlayTrigger>
                    </h4>
                    <div className="well" style={wellStyles}>
                        <Button  className="well" style={btnStyles}  size={'lg'} variant="tertiary" onClick={() => handleMediatorLogin('/login')}>External Login</Button>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default App;
